import { createFileRoute } from "@tanstack/react-router";
import { CostsPage } from "@/features/vehicle-management/costs";

// Vehicle management's Costs page (ADR 0017); it says so when the module is off.
export const Route = createFileRoute("/costs")({
  component: CostsPage,
});
